(function(){
  if(window.location.pathname !== '/pages/for-therapists') return;
  var ROCKET='https://cdn.shopify.com/s/files/1/0783/1512/7019/files/Folder_2_2026_Ready_Rocket_Social_Media_Designs_copy_3.png?v=1780961517';
  var LOGO='https://cdn.shopify.com/s/files/1/0783/1512/7019/files/2025_New_charac._RR_Wix_Website_Images_JPEG_3_copy_2.png?v=1780961742';
  var PROVIDERS=[
    {name:'Gabby Smith',loc:'Queensland',web:'https://www.paediatricpotentials.com.au'},
    {name:'Esther Vella',loc:'Queensland',web:''},
    {name:'Donna Jones',loc:'Queensland',web:''},
    {name:'The OT Room Townsville',loc:'Queensland',web:'https://www.theotroomtownsville.com'},
    {name:'Making a Difference OT',loc:'Queensland',web:'https://www.makingadifferenceot.com.au'},
    {name:'Evergrow OT',loc:'Queensland',web:'https://www.evergrowot.com.au'},
    {name:'Wildflower Kids Therapy',loc:'Queensland',web:'https://www.wildflowerkidstherapy.com.au'},
    {name:'Therapy Partners',loc:'Queensland',web:'https://therapypartners.com.au'},
    {name:'Spectrum Village',loc:'Queensland',web:'https://spectrumvillage.com.au'},
    {name:'Quest Therapy Services',loc:'Queensland',web:'https://www.questtherapyservices.com.au'},
    {name:'Kylie Moore',loc:'New South Wales',web:'https://www.facebook.com/cameronroadfdc/'},
    {name:'Nadine Kids OT',loc:'New South Wales',web:''},
    {name:'Samantha Carlton',loc:'New South Wales',web:''},
    {name:'OT Takes a Village',loc:'New South Wales',web:'https://www.ottakesavillage.com.au'},
    {name:'Kidlets Allied Health',loc:'New South Wales',web:'https://www.kidletsah.com.au'},
    {name:'Macquarie OT',loc:'New South Wales',web:'https://www.macquarieot.com.au'},
    {name:'Building Bridges Early Intervention',loc:'New South Wales',web:'https://www.buildingbridgesearlyintervention.com'},
    {name:'Rebecca Ford OT',loc:'New South Wales',web:''},
    {name:'Cassandra Shaw',loc:'New South Wales',web:'https://www.talkplaygrowtherapy.com.au'},
    {name:'Care 2 Communicate',loc:'New South Wales',web:'https://care2communicate.com.au'},
    {name:'Its More Than Therapy',loc:'New South Wales',web:'https://www.imtt.com.au'},
    {name:'Concentric',loc:'New South Wales',web:'https://www.concentric.com.au'},
    {name:'Maria Lappas',loc:'Victoria',web:''},
    {name:'Jen Graham',loc:'Victoria',web:''},
    {name:'Emily Watts',loc:'Victoria',web:''},
    {name:'Grace Murray',loc:'Victoria',web:'https://www.sproutlearning.com.au'},
    {name:'Maddy Tobias',loc:'Victoria',web:''},
    {name:'Sarah Jensen',loc:'Victoria',web:''},
    {name:'Affirm OT',loc:'Victoria',web:''},
    {name:'Janelle Chilton',loc:'Victoria',web:''},
    {name:'Playtime OT for Kids',loc:'Victoria',web:'https://www.playtimeotforkids.com.au'},
    {name:'Elissa Vellios',loc:'Victoria',web:''},
    {name:'Only About Kids OT',loc:'Victoria',web:'https://www.onlyaboutkidsot.com.au'},
    {name:'Golnaz Behgoo',loc:'Victoria',web:'https://www.sunrosechildrenstherapy.com.au'},
    {name:'Superyou Fremantle',loc:'Western Australia',web:'https://www.superyou.org.au'},
    {name:'Superyou Wanneroo',loc:'Western Australia',web:'https://www.superyou.org.au'},
    {name:'Vivid Therapy WA',loc:'Western Australia',web:'https://www.vividtherapywa.com.au'},
    {name:'Katarina Visic',loc:'Western Australia',web:'https://www.downsouththerapy.com.au'},
    {name:'Anna Gething',loc:'Western Australia',web:'https://www.downsouththerapy.com.au'},
    {name:'Hannah Lipscomb',loc:'Western Australia',web:'https://www.coasttocountryot.com.au'},
    {name:'Next Challenge',loc:'Western Australia',web:'https://www.nextchallenge.com.au'},
    {name:'Function Focused Therapy',loc:'Western Australia',web:'https://www.functionfocusedtherapy.com'},
    {name:'Concentric',loc:'Western Australia',web:'https://www.concentric.com.au'},
    {name:'Connect Paediatric Therapy Services',loc:'Western Australia',web:'https://www.connectpts.com.au'},
    {name:'OT With Fi',loc:'Western Australia',web:''},
    {name:'Making Milestones',loc:'South Australia',web:'https://www.makingmilestonessa.com.au'},
    {name:'Bianca Belevski',loc:'South Australia',web:''},
    {name:'Balanced OT',loc:'Tasmania',web:'https://www.balancedot.com.au'},
    {name:'Lisa Attrill',loc:'Tasmania',web:''},
    {name:'Foundations First Pediatrics',loc:'United States',web:'https://www.foundationsfirstpediatrics.com'},
    {name:'Venture Speech',loc:'United States',web:'https://www.venturespeech.com'},
    {name:'Strong Roots Kids',loc:'United States',web:'https://www.strongrootskids.com'},
    {name:'Hilary Cooper',loc:'New Zealand',web:''}
  ];
  var AU=['Queensland','New South Wales','Victoria','Western Australia','South Australia','Tasmania','Australian Capital Territory','Northern Territory','New Zealand','United States'];
  function esc(s){return(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function buildHTML(){
    return '<style>'+
      '.rr-wrap{max-width:1200px;margin:0 auto;padding:40px 20px}'+
      '.rr *,.rr *::before,.rr *::after{box-sizing:border-box;margin:0;padding:0}'+
      '.rr{background:#4b6d99;border-radius:18px;padding:clamp(20px,4vw,36px) clamp(16px,3vw,28px);font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Helvetica,Arial,sans-serif;color:#fff;width:100%}'+
      '.rr-header{display:flex;align-items:center;justify-content:center;gap:16px;margin-bottom:clamp(16px,3vw,24px);flex-wrap:wrap}'+
      '.rr-logo{height:clamp(48px,8vw,72px);width:auto;flex-shrink:0}'+
      '.rr-title{font-size:clamp(16px,3vw,24px);font-weight:700;color:#fff;letter-spacing:-0.2px;line-height:1.3;text-align:left}'+
      '@media(max-width:480px){.rr-header{flex-direction:column}.rr-title{text-align:center}}'+
      '.rr-controls{display:flex;gap:12px;flex-wrap:nowrap;margin-bottom:14px;align-items:center}'+
      '@media(max-width:540px){.rr-controls{flex-direction:column;gap:10px}}'+
      '.rr-sw{flex:1 1 0;min-width:0;position:relative}'+
      '.rr-sw svg{position:absolute;left:14px;top:50%;transform:translateY(-50%);pointer-events:none}'+
      '.rr-search{width:100%;height:44px;padding:0 16px 0 38px;border-radius:40px;border:none;background:#fff;color:#333;font-family:inherit;font-size:clamp(13px,2vw,15px);outline:none}'+
      '.rr-search::placeholder{color:#aab}'+
      '.rr-search:focus{box-shadow:0 0 0 2px #40bfc2}'+
      '.rr-dw{flex:0 0 auto;width:clamp(160px,32%,220px);position:relative}'+
      '.rr-dw svg{position:absolute;right:14px;top:50%;transform:translateY(-50%);pointer-events:none}'+
      '.rr-select{width:100%;height:44px;padding:0 36px 0 16px;border-radius:40px;border:none;background:#fff;color:#333;font-family:inherit;font-size:clamp(13px,2vw,14px);cursor:pointer;outline:none;appearance:none;-webkit-appearance:none}'+
      '.rr-select:focus{box-shadow:0 0 0 2px #40bfc2}'+
      '@media(max-width:540px){.rr-dw{width:100%}}'+
      '.rr-panel{background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.18);border-radius:14px;min-height:90px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:clamp(14px,3vw,20px) clamp(16px,3vw,28px);margin-bottom:18px}'+
      '.rr-pname{font-size:clamp(16px,3vw,20px);font-weight:700;color:#40bfc2;margin-bottom:4px;line-height:1.3}'+
      '.rr-ploc{font-size:clamp(12px,2.5vw,14px);color:rgba(255,255,255,0.75);margin-bottom:10px}'+
      '.rr-plinks{display:flex;gap:14px;flex-wrap:wrap;justify-content:center}'+
      '.rr-plinks a{color:#40bfc2;font-size:13px;text-decoration:underline;text-underline-offset:2px}'+
      '.rr-hint{font-size:13px;color:rgba(255,255,255,0.38);font-style:italic}'+
      '.rr-count{font-size:11px;color:rgba(255,255,255,0.38);text-align:center;margin-bottom:14px;letter-spacing:0.08em;text-transform:uppercase}'+
      '.rr-group{margin-bottom:22px}'+
      '.rr-glabel{font-size:10px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,0.42);margin-bottom:10px;padding-left:2px}'+
      '.rr-grid{display:flex;flex-wrap:wrap;gap:clamp(6px,1.5vw,10px)}'+
      '.rr-rocket{background:none;border:none;padding:3px;cursor:pointer;transition:transform 0.18s cubic-bezier(.34,1.56,.64,1),filter 0.18s;border-radius:6px;outline:none;-webkit-tap-highlight-color:transparent;touch-action:manipulation}'+
      '.rr-rocket:hover{transform:translateY(-5px) scale(1.1)}'+
      '.rr-rocket:focus-visible{box-shadow:0 0 0 2px #40bfc2;border-radius:8px}'+
      '.rr-rocket.active{transform:translateY(-7px) scale(1.14);filter:drop-shadow(0 4px 14px rgba(64,191,194,0.7))}'+
      '.rr-rocket img{width:clamp(44px,8vw,64px);height:auto;display:block}'+
      '.rr-none{text-align:center;color:rgba(255,255,255,0.38);font-style:italic;padding:24px;font-size:14px}'+
      '</style>'+
      '<div class="rr-wrap"><div class="rr" id="rr-root">'+
      '<div class="rr-header">'+
      '<img class="rr-logo" src="'+LOGO+'" alt="Ready Rocket"/>'+
      '<div class="rr-title">Ready Rocket Therapy Program<br>Licensed Providers</div>'+
      '</div>'+
      '<div class="rr-controls">'+
      '<div class="rr-sw"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="6" cy="6" r="4.5" stroke="#aab" stroke-width="1.4"/><line x1="9.5" y1="9.5" x2="13" y2="13" stroke="#aab" stroke-width="1.4" stroke-linecap="round"/></svg>'+
      '<input class="rr-search" id="rr-q" type="text" placeholder="Search by name or location" oninput="rrFilter()" autocomplete="off" aria-label="Search providers"/></div>'+
      '<div class="rr-dw"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="#aab" stroke-width="1.4" stroke-linecap="round"/></svg>'+
      '<select class="rr-select" id="rr-loc" onchange="rrFilter()" aria-label="Filter by state"></select></div>'+
      '</div>'+
      '<div class="rr-panel" id="rr-panel"><span class="rr-hint">Hover or tap a rocket to see provider details</span></div>'+
      '<div id="rr-count" class="rr-count"></div>'+
      '<div id="rr-body"></div>'+
      '</div></div>';
  }
  function inject(){
    // Find the Real Therapist Reviews section (key: blocks_jmY6dc)
    var target = document.querySelector('[id*="blocks_jmY6dc"]');
    if(!target){
      // Fallback: look for section containing testimonial/review heading
      var allSections = document.querySelectorAll('[id^="shopify-section-"]');
      for(var i=0;i<allSections.length;i++){
        if(allSections[i].textContent.toLowerCase().includes('real therapist')) { target = allSections[i]; break; }
      }
    }
    var wrapper = document.createElement('div');
    wrapper.id = 'rr-provider-directory';
    wrapper.innerHTML = buildHTML();
    if(target && target.parentNode){
      target.parentNode.insertBefore(wrapper, target);
    } else {
      // Final fallback: append before footer
      var footer = document.querySelector('footer') || document.querySelector('[id*="footer"]');
      if(footer && footer.parentNode) footer.parentNode.insertBefore(wrapper, footer);
      else document.body.appendChild(wrapper);
    }
    initRR();
  }
  function initRR(){
    var all=PROVIDERS.slice(), fil=all.slice();
    var sel=document.getElementById('rr-loc');
    if(!sel) return;
    var seen={}, locs=[];
    var opt0=document.createElement('option'); opt0.value=''; opt0.textContent='All locations'; sel.appendChild(opt0);
    all.forEach(function(p){if(!seen[p.loc]){seen[p.loc]=1;locs.push(p.loc);}});
    locs.sort(function(a,b){var ai=AU.indexOf(a),bi=AU.indexOf(b);if(ai!==-1&&bi!==-1)return ai-bi;if(ai!==-1)return -1;if(bi!==-1)return 1;return a.localeCompare(b);});
    locs.forEach(function(l){var o=document.createElement('option');o.value=o.textContent=l;sel.appendChild(o);});
    function showPanel(p,btn){
      var prev=document.querySelector('.rr-rocket.active'); if(prev) prev.classList.remove('active');
      if(btn) btn.classList.add('active');
      var links=p.web?'<a href="'+p.web+'" target="_blank" rel="noopener noreferrer">Visit website</a>':'';
      document.getElementById('rr-panel').innerHTML='<div class="rr-pname">'+esc(p.name)+'</div><div class="rr-ploc">'+esc(p.loc)+'</div>'+(links?'<div class="rr-plinks">'+links+'</div>':'');
    }
    window.rrFilter=function(){
      var q=(document.getElementById('rr-q').value||'').toLowerCase();
      var loc=document.getElementById('rr-loc').value;
      fil=all.filter(function(p){return(!q||p.name.toLowerCase().includes(q)||p.loc.toLowerCase().includes(q))&&(!loc||p.loc===loc);});
      render();
    };
    function render(){
      var body=document.getElementById('rr-body'), cEl=document.getElementById('rr-count');
      document.getElementById('rr-panel').innerHTML='<span class="rr-hint">Hover or tap a rocket to see provider details</span>';
      if(!fil.length){body.innerHTML='<div class="rr-none">No providers found.</div>';cEl.textContent='';return;}
      cEl.textContent=fil.length+' licensed provider'+(fil.length===1?'':'s');
      var g={},ord=[];
      fil.forEach(function(p){if(!g[p.loc]){g[p.loc]=[];ord.push(p.loc);}g[p.loc].push(p);});
      ord.sort(function(a,b){var ai=AU.indexOf(a),bi=AU.indexOf(b);if(ai!==-1&&bi!==-1)return ai-bi;if(ai!==-1)return -1;if(bi!==-1)return 1;return a.localeCompare(b);});
      body.innerHTML=ord.map(function(l){return'<div class="rr-group"><div class="rr-glabel">'+esc(l)+' ('+g[l].length+')</div><div class="rr-grid" id="rg-'+encodeURIComponent(l)+'"></div></div>';}).join('');
      ord.forEach(function(l){
        var grid=document.getElementById('rg-'+encodeURIComponent(l));
        g[l].forEach(function(p){
          var btn=document.createElement('button'); btn.className='rr-rocket';
          btn.setAttribute('aria-label',p.name+' - '+p.loc); btn.title=p.name;
          var img=document.createElement('img'); img.src=ROCKET; img.alt=p.name; img.loading='lazy';
          btn.appendChild(img);
          ['mouseenter','focus','click'].forEach(function(ev){btn.addEventListener(ev,function(){showPanel(p,btn);});});
          grid.appendChild(btn);
        });
      });
    }
    render();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',inject);}else{inject();}
})();
